import { ROUTE_NAMES } from '@/utils/const.js';
import { USER_ACTIONS, USER_SUBJECTS } from '@/utils/const';
const SpcAnalysis = () => import('./pages');

const moduleRoute = {
  path: 'quality/spc-analysis',
  name: 'SpcAnalysis',
  component: SpcAnalysis,
  meta: {
    allowAnonymous: false,
    ability: {
      subject: USER_SUBJECTS.PRODUCT_SPC_ANALYSIS,
      action: USER_ACTIONS.READ,
    },
    isNextAppPage: true,
  },
};

export default (router) => {
  router.addRoute(ROUTE_NAMES.BASE_LAYOUT, moduleRoute);
};
